import { render } from "./Event-Details.vue?vue&type=template&id=3475b3a5&scoped=true"
import script from "./Event-Details.vue?vue&type=script&lang=js"
export * from "./Event-Details.vue?vue&type=script&lang=js"

import "./Event-Details.vue?vue&type=style&index=0&id=3475b3a5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3475b3a5"

export default script